import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { X, MessageCircle } from "lucide-react";
import api, { resolveImg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../context/NotificationContext";

export const MessageNotification = () => {
  const { user } = useAuth();
  const { counts } = useNotifications();
  const navigate = useNavigate();
  const [notif, setNotif] = useState(null);
  const lastIdRef = useRef(null);
  const prevCountRef = useRef(null);

  useEffect(() => {
    if (!user || !user.onboarded) return;
    const cur = counts.messages || 0;
    const prev = prevCountRef.current;
    prevCountRef.current = cur;
    if (prev === null || cur <= prev) return;
    api.get("/messages/latest-unread").then(({ data }) => {
      if (!data || !data.match_id) return;
      if (data.message_id && data.message_id === lastIdRef.current) return;
      if (window.location.pathname === `/chat/${data.match_id}` || window.location.pathname === "/matchs") return;
      lastIdRef.current = data.message_id || null;
      setNotif(data);
    }).catch(() => {});
  }, [counts.messages, user]);

  if (!user || !notif) return null;

  const goReply = () => {
    const matchId = notif.match_id;
    setNotif(null);
    navigate(`/chat/${matchId}`);
  };

  return (
    <div className="fixed inset-0 z-[75] bg-black/50 backdrop-blur-[2px] flex items-center justify-center px-6">
      <div data-testid="message-notification" className="w-full max-w-xs bg-white rounded-3xl p-6 text-center shadow-2xl relative">
        <button data-testid="message-notification-close" onClick={() => setNotif(null)} aria-label="Fermer" className="absolute top-3 right-3 text-kora-muted hover:text-kora-ink p-1">
          <X size={18} />
        </button>
        {notif.sender_photo ? (
          <img src={resolveImg(notif.sender_photo)} alt={notif.sender_name} className="w-20 h-20 rounded-full object-cover mx-auto border-4 border-kora-terracotta" />
        ) : (
          <span className="w-20 h-20 rounded-full bg-kora-terracotta mx-auto flex items-center justify-center text-white text-2xl font-black">{(notif.sender_name || "?")[0]}</span>
        )}
        <p data-testid="message-notification-text" className="font-display font-bold text-lg text-kora-ink mt-4">
          {notif.sender_name} vous a envoyé un message 💬
        </p>
        <button data-testid="message-notification-reply" onClick={goReply} className="w-full mt-5 bg-kora-terracotta text-white rounded-full py-3.5 font-bold hover:bg-[#C94F2B] transition-colors flex items-center justify-center gap-2">
          <MessageCircle size={17} /> Répondre
        </button>
        <button data-testid="message-notification-dismiss" onClick={() => setNotif(null)} className="w-full mt-2 text-kora-muted py-2 text-sm font-medium">Fermer</button>
      </div>
    </div>
  );
};

export default MessageNotification;
